
import React from 'react';
import { Link } from 'react-router-dom';

// windowオブジェクトにgtagを追加
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const CTA: React.FC = () => {
  const handleFormClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17931041617/eH8qCOvAwPIbENH2l-ZC',
        'value': 1.0,
        'currency': 'JPY'
      });
    }
  };

  const handleLineClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17931041617/eH8qCOvAwPIbENH2l-ZC',
        'value': 1.0,
        'currency': 'JPY'
      });
    }
  };

  return (
    <>
      {/* 関連ページへの誘導 */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-xl font-bold text-gray-900 text-center mb-6">
            その他のお悩みはこちら
          </h2>
          <div className="grid md:grid-cols-3 gap-4 max-w-4xl mx-auto">
            <Link
              to="/nouchi"
              className="bg-white rounded-lg p-5 border border-gray-200 hover:shadow-md hover:border-orange-300 transition-all duration-300 cursor-pointer group"
            >
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-seedling-line text-orange-500 text-xl"></i>
                <h3 className="font-bold text-gray-900">農地処分</h3>
              </div>
              <p className="text-sm text-gray-600">農地法の規制対応から国庫帰属制度まで</p>
            </Link>
            
            <Link
              to="/blog/sanrin-syobun-5-houhou"
              className="bg-white rounded-lg p-5 border border-gray-200 hover:shadow-md hover:border-orange-300 transition-all duration-300 cursor-pointer group"
            >
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-plant-line text-orange-500 text-xl"></i>
                <h3 className="font-bold text-gray-900">山林処分</h3>
              </div>
              <p className="text-sm text-gray-600">山林を処分する5つの方法を解説</p>
            </Link>
            
            <Link
              to="/blog/kokko-kizon-shinsei-houhou"
              className="bg-white rounded-lg p-5 border border-gray-200 hover:shadow-md hover:border-orange-300 transition-all duration-300 cursor-pointer group"
            >
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-government-line text-orange-500 text-xl"></i>
                <h3 className="font-bold text-gray-900">国庫帰属制度</h3>
              </div>
              <p className="text-sm text-gray-600">申請方法と必要書類を詳しく解説</p>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section id="cta" className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              まずは無料相談から
            </h2>
            <p className="text-xl text-gray-200 mb-4">
              共有名義・相続未分割の不動産でお困りの方、<br className="hidden md:block" />
              お気軽にご相談ください
            </p>
            <p className="text-gray-300 mb-12 flex items-center justify-center">
              <i className="ri-time-line mr-2"></i>
              3営業日以内に心を込めてお返事いたします
            </p>
            
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <a
                href="tel:0525880874"
                className="flex flex-col items-center gap-4 p-8 bg-white/10 backdrop-blur rounded-xl hover:bg-white/20 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-full">
                  <i className="ri-phone-line text-white text-3xl"></i>
                </div>
                <div>
                  <p className="font-bold text-white mb-2">お電話でのご相談</p>
                  <p className="text-2xl font-bold text-orange-400">052-588-0874</p>
                  <p className="text-sm text-gray-300 mt-2">平日 9:00～18:00</p>
                </div>
              </a>
              
              <a
                href="https://forms.gle/zPw2NXXr6K7nXgAm6"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleFormClick}
                className="flex flex-col items-center gap-4 p-8 bg-white/10 backdrop-blur rounded-xl hover:bg-white/20 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-full">
                  <i className="ri-mail-line text-white text-3xl"></i>
                </div>
                <div>
                  <p className="font-bold text-white mb-2">メールでのご相談</p>
                  <p className="text-orange-400 font-semibold">24時間受付</p>
                  <p className="text-sm text-gray-300 mt-2">お気軽にどうぞ</p>
                </div>
              </a>
              
              <a
                href="https://lin.ee/34dhahY"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLineClick}
                className="flex flex-col items-center gap-4 p-8 bg-white/10 backdrop-blur rounded-xl hover:bg-white/20 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-green-500 rounded-full">
                  <i className="ri-line-fill text-white text-3xl"></i>
                </div>
                <div>
                  <p className="font-bold text-white mb-2">LINEでのご相談</p>
                  <p className="text-green-400 font-semibold">24時間受付</p>
                  <p className="text-sm text-gray-300 mt-2">お気軽にメッセージを</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CTA;
